import { useEffect } from 'react';
import { createUserManager } from './userManager';
import { AUTHREQ } from '../../../constants/constants';
import { RouteComponentProps } from 'react-router-dom';
import { useUserManager } from './UserManagerContext';

interface MatchParams {
  robot: string;
}

const AuthCallback: React.FC<RouteComponentProps<MatchParams>> = ({ match }) => {
  const robot = match.params.robot;
  const { setUserManager } = useUserManager();
  
  useEffect(() => {
    console.log(`Attempting to process the sign-in callback for ${robot} ...`);
    if (AUTHREQ){
      const userManager = createUserManager(robot);
      console.log(robot,userManager)
      setUserManager(userManager);
      userManager.signinRedirectCallback()
        .then((user) => {
          console.log("Callback processed, user:", user);
          const redirectUrl = `/${robot}`;
          window.location.href = redirectUrl;
        })
        .catch(err => {
          console.error("Error in sign-in callback:", err);
        });
    }else{
      console.log(`Authentication required set to ${AUTHREQ}`)
    }
  }, []);
  
  
  

  return <div>Logging in...</div>;
};

export default AuthCallback;


// import React, { useEffect } from 'react';
// import { RouteComponentProps } from 'react-router-dom';
// import { createUserManager } from './userManager';
// import { useUserManager } from '../contexts/UserManagerContext';
// import { AUTHREQ } from '../../../constants/constants';

// interface MatchParams {
//   robot: string;
// }

// const AuthCallback: React.FC<RouteComponentProps<MatchParams>> = ({ match }) => {
//   const { robot } = match.params;
//   const { setUserManager } = useUserManager();

//   useEffect(() => {
//     const login = async () => {
//       try {
//         const userManager = createUserManager(robot);
//         setUserManager(userManager); // 

//         const user = await userManager.signinRedirectCallback();
//         window.location.href = user.state?.targetUrl || `/dashboard?robot=${robot}`;
//       } catch (error) {
//         console.error('Error during sign-in callback:', error);
//       }
//     };

//     if (AUTHREQ) {
//       login();
//     }
//   }, [robot, setUserManager]);

//   return <div>Logging in with robot: {robot}...</div>;
// };

// export default AuthCallback;